// @flow
import client from '../../client'
import format from '../../utils/format'

// Types
import type { TCustomerProfile } from './getCustomerProfiles'

// API Endpoints
export const CUSTOMER_PROFILE_ENDPOINT = '/travel_agent/profiles/{0}/'

/**
 * Returns the customer profile for a given profile ID
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const getCustomerProfile = (data: {
  profile_id?: number,
}): Promise<TCustomerProfile> => {
  const { profile_id } = data
  const endpoint = format(CUSTOMER_PROFILE_ENDPOINT, profile_id)

  return client.get(endpoint)
}

export default getCustomerProfile
